import { Component, OnInit } from '@angular/core';
import { IUserContactGroup } from '../../store/models/user-group.model';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CampaignService } from '../../store/services/campaign.service';
import { ICampaign } from '../../store/models/campaigns.model';
import { ISelectItem } from '../../store/models/select.model';
import * as moment from 'moment';

@Component({
  selector: 'app-send-to-campaign',
  templateUrl: './send-to-campaign.component.html',
  styleUrls: ['./send-to-campaign.component.scss'],
})
export class SendToCampaignComponent implements OnInit {
  inputForm: FormGroup;

  componentReady: boolean;

  activeCampaigns: ICampaign[];

  constructor(private readonly campaignService: CampaignService) {}

  ngOnInit(): void {
    this.campaignService.getActiveCampaigns().subscribe(result => {
      this.activeCampaigns = result.items;
      this.inputForm.addControl(
        'campaign_id',
        new FormControl('', [Validators.required])
      );
      this.inputForm.addControl(
        'start_date',
        new FormControl('', [Validators.required])
      );
      this.componentReady = true;
    });
  }

  getCampaignsSelectItems(): ISelectItem[] {
    return this.activeCampaigns.map(c => ({
      label: c.campaign_name,
      value: c.campaign_id,
    }));
  }

  get campaignId(): AbstractControl {
    return this.inputForm.get('campaign_id');
  }

  get startDate(): AbstractControl {
    return this.inputForm.get('start_date');
  }

  getStartDate() {
    return moment().startOf('day').toDate();
  }
}
